import { H5 } from '@zet/design-system'
import { i18n } from '@zet/localization'

interface CrossSellingBottomSheetHeadingProps {
  customerName: string
  brandName: string
}

const CrossSellingBottomSheetHeading = ({
  customerName,
  brandName,
}: CrossSellingBottomSheetHeadingProps) => {
  return (
    <H5 className="mx-2 items-center text-center">
      {i18n.t('creditCardCrossSelling.bottomSheetHeading', {
        customerName: customerName,
        brandName: brandName,
      })}
    </H5>
  )
}

export default CrossSellingBottomSheetHeading
